// extracted by mini-css-extract-plugin
export default {"transparent":"Sidebar-module__transparent___icO1w"};